import { UserDto } from '~modules/user/model';
import { CancelBtn } from '~shared/ui/button/cancel-btn';
import { InputItem } from '~shared/ui/input-item/input-item';

import { UserSearchSelect } from './user-search-select';

interface RoleItemProps {
	user: UserDto | null;
	name: string;
	onChange: (data: { user: UserDto | null; name: string }) => void;
	onDelete?: (user: UserDto) => void;
}

export function RoleItem({ name, user, onChange, onDelete }: RoleItemProps) {
	return (
		<>
			<td className="role-item__user">
				{user ? (
					<InputItem value={user.name} disabled />
				) : (
					<UserSearchSelect defaultValue={user ?? null} onSelectUser={user => onChange({ user, name })} />
				)}
			</td>
			<td className="role-item__name">
				{name ? (
					<InputItem value={name} disabled />
				) : (
					<input
						type="text"
						value={name}
						onChange={e => onChange({ name: e.target.value, user })}
						placeholder="Введите роль"
					/>
				)}
			</td>
			<td>{onDelete && user && <CancelBtn onClick={() => user && onDelete(user)} />}</td>
		</>
	);
}
